export default __webpack_public_path__ + "static/media/xettle.cdf1539f.png";